import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { Helmet } from 'react-helmet'

import GlobalStyle from '../../theme/global-style'
import { theme } from '../../theme/theme-style'

import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import { LayoutProvider } from '../../contexts/LayoutContext'
import { StyledMainLayout } from './Layout.styled'
import ButtonDownloadOverlay from '../ButtonDownload/ButtonDownloadOverlay'
import { useNavigationQuery } from '../../graphql/useNavigationQuery'
import { NAVBAR_HEIGHT } from '../../theme/constants'
import { deviceMax } from '../../theme/breakpoints'
import useMediaQuery from '../../hooks/useMediaQuery'

const Layout = ({ light = false, children, className }) => {
  const [scroll, setScroll] = useState(false)

  const isTablet = useMediaQuery(deviceMax.tablet)
  const data = useNavigationQuery()
  let oldScrollY = 0

  const controlDirection = () => {
    const navbarHeight = isTablet ? NAVBAR_HEIGHT.mobile : NAVBAR_HEIGHT.desktop
    if (window.scrollY > oldScrollY && window.scrollY > navbarHeight) {
      setScroll(true)
    } else {
      setScroll(false)
    }
    oldScrollY = window.scrollY
  }

  useEffect(() => {
    window.addEventListener('scroll', controlDirection)
    return () => window.removeEventListener('scroll', controlDirection)
  }, [])

  const companyNavigation =
    data?.contentfulComponentNavigationFooter?.companyNavigation
  const profilNavigation =
    data?.contentfulComponentNavigationFooter?.profilNavigation
  const footerLinks = data?.contentfulComponentNavigationFooter?.footerLinks

  return (
    <LayoutProvider>
      <Helmet>
        {/*OneTrust Cookies Consent Notice start for constellium.com*/}
        <script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          data-language="en"
          type="text/javascript"
          charSet="UTF-8"
          data-domain-script="5c3c1845-d10c-4c34-bd75-1cc7a7b4c0ee"
        ></script>
        <script type="text/javascript">
          {'function OptanonWrapper() { }'}
        </script>
        {/*OneTrust Cookies Consent Notice end for constellium.com*/}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        <Header
          companyNavigation={companyNavigation}
          profilNavigation={profilNavigation}
          light={light}
          scroll={scroll}
        />
        <GlobalStyle />
        <StyledMainLayout className={className} role="main" id="content">
          <ButtonDownloadOverlay />
          {children}
        </StyledMainLayout>
        <Footer footerLinks={footerLinks} light={light} />
      </ThemeProvider>
    </LayoutProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
